import { createSvgComponent } from "../../icon/createSvgComponent";
import Chevrondown from "@core/__generated__/icon/figma/chevrondown.svg";
export default createSvgComponent(Chevrondown);